import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useTime } from '../../../hooks/useTime'
import { useHook } from '../../../lenteHooks'
import { OverviewItem } from '../../overview/OverviewItem'

export const BirthOrDeathDateFromCommitmentVersion = () => {
  const translate = useTranslate()
  const { data: time } = useTime()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  const { data: commitmentVersion } = useHook(
    'fetchers.life.useFetchCommitmentVersionLatest',
  )({ ownerId, tenantId })

  const { hint, iconName, label } = dateUtils.isValidDate(
    commitmentVersion?.insured?.deathDate,
  )
    ? {
        hint: translate('birthOrDeathDate.deathdate'),
        iconName: 'Tomb' as const,
        label: dateUtils.formatDateAndAge({
          startDate: commitmentVersion?.insured?.birthDate,
          endDate: commitmentVersion?.insured?.deathDate,
          displayDate: 'endDate',
          translatedYear: translate('age.year'),
          translatedMonth: translate('age.month'),
        }),
      }
    : {
        hint: translate('birthOrDeathDate.birthdate'),
        iconName: 'Cake' as const,
        label: dateUtils.formatDateAndAge({
          startDate: commitmentVersion?.insured?.birthDate,
          endDate: time,
          translatedYear: translate('age.year'),
          translatedMonth: translate('age.month'),
        }),
      }

  return (
    <OverviewItem title={hint} iconName={iconName}>
      {label}
    </OverviewItem>
  )
}
